import React from 'react';
import { TableRow, TableCell, Checkbox } from '@mui/material';

const CELL_STYLE = {
  fontWeight: 600,
  backgroundColor: 'grey.100',
  borderRight: '1px solid',
  borderColor: 'divider',
  py: 1,
  px: 1.5,
} as const;

interface EmployeeSpreadsheetHeaderProps {
  allSelected: boolean;
  someSelected: boolean;
  onSelectAll: (checked: boolean) => void;
}

export const EmployeeSpreadsheetHeader: React.FC<EmployeeSpreadsheetHeaderProps> = ({
  allSelected,
  someSelected,
  onSelectAll,
}) => (
  <TableRow>
    <TableCell
      padding="checkbox"
      sx={{
        ...CELL_STYLE,
        width: 48,
        minWidth: 48,
        maxWidth: 48,
        textAlign: 'center',
        p: 0,
        borderRight: 'none',
      }}
    >
      <Checkbox
        indeterminate={someSelected && !allSelected}
        checked={allSelected}
        onChange={(_, checked) => onSelectAll(checked)}
        size="small"
      />
    </TableCell>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 100 }}>이름 *</TableCell>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 90 }}>입사일</TableCell>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 80 }}>급여유형</TableCell>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 100 }}>시급/월급</TableCell>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 70 }}>급여일</TableCell>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 70 }}>부양가족</TableCell>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 140 }}>퇴직금</TableCell>
    <TableCell sx={{ ...CELL_STYLE, minWidth: 60 }}>상태</TableCell>
    <TableCell sx={{ ...CELL_STYLE, width: 48 }} />
  </TableRow>
);
